/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./airdropInviter.vue?vue&type=template&id=81ad5256&scoped=true"
import script from "./airdropInviter.vue?vue&type=script&lang=js"
export * from "./airdropInviter.vue?vue&type=script&lang=js"
import style1 from "./airdropInviter.vue?vue&type=style&index=1&id=81ad5256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ad5256",
  null
  
)

export default component.exports